<!--
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
-->
<lms-notes-data-list [loadData]='loadData' [selectedTab]='selectedTab' [subTypes]='subTypes' [winCode]="'LWLD'" [notesType]="'L'"
    [blankMessage]='blankMessage' [errorMessage]='errorMessage' [noteTextParent]='noteTextParent'></lms-notes-data-list>